/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/InputOutput
 * @desc ProtocolValue field type input/output
 */

import { EntityFormShowEditInputOutput } from 'labstep-web/components/Entity/Form/ShowEdit/InputOutput';
import type React from 'react';
import type { IProtocolValueFormShowEditInputOutputProps } from './types';

export const ProtocolValueFormShowEditInputOutput: React.FC<
  IProtocolValueFormShowEditInputOutputProps
> = ({ protocolValue }) => (
  <EntityFormShowEditInputOutput
    data-cy="components/ProtocolValue/Form/ShowEdit/InputOutput"
    entity={protocolValue}
  />
);
